import { render, staticRenderFns } from "./InstancesSlimList.vue?vue&type=template&id=6229a80e"
import script from "./InstancesSlimList.vue?vue&type=script&lang=js"
export * from "./InstancesSlimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports